export default "__VITE_ASSET__DX0vTHEq__"